import ReactDOM from 'react-dom';

const ActionResultsPortal: React.FC = ({ children }) => {
  const adyenResultContainer = document.querySelector('.adyen-checkout__qr-loader');

  if (adyenResultContainer)
    return ReactDOM.createPortal(
      <div className="custom-qr-code-results">{children}</div>,
      adyenResultContainer as Element,
    );

  return null;
};

export default ActionResultsPortal;
